var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.labels != null)?_c('thead',[_c('tr',[_vm._l((_vm.labels),function(th,index){return _c('th',{key:index,class:_vm.me(th.data),attrs:{"title":'Ordenar por ' + th.label},on:{"click":function($event){_vm.insert_order(th)}}},[(_vm.me(th.data) != 'NONE')?_c('i',{staticClass:"fa",class:{
					'fa-sort-amount-asc': _vm.me(th.data) == 'ASC',
					'fa-sort-amount-desc': _vm.me(th.data) == 'DESC',
				}}):_vm._e(),_vm._v("\n\t\t\t"+_vm._s(th.label)+"\n\t\t")])}),_vm._v(" "),(_vm.actions)?_c('th',{staticClass:"text-right"},[_vm._v("Ações")]):_vm._e()],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-031ab4aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app-components/table/thead.vue
// module id = null
// module chunks = 